import store from 'utils/store/withMiddleware'
import makeMembers from './makeMembers'
import getGender from './getGender'
import { dateToString, onlyDigits } from '@hc-frontend/utils'
import { findApplicant } from '@hc-frontend/business'

const EMAIL_SALE_CENTER =
  // cspell:disable-next-line
  'emailtosalesforce@1338o9gmrdhsz0odhxgxfet1ot22yi2rzkiy3z8xobjavo6rjr.6g-2eolqeay.na174.le.salesforce.com'

function makeBase({ valuesForm, agentInformation, salesCenterAgent = false }) {
  const state = store.getState()
  const hcStorage = state.hcStorage
  const applicant = findApplicant(hcStorage.members)
  let completePhone = valuesForm.phone.replace(/\((\d{3})\) (\d{3})-(\d{4})/, '$1-$2-$3')
  valuesForm.phoneExt ? (completePhone += ' ext. ' + valuesForm.phoneExt) : completePhone

  const result = {
    template_content: [],
    message: {
      to: [
        { email: valuesForm.email, type: 'to' },
        { email: agentInformation.email, type: 'bcc' }
      ],
      bcc_address: salesCenterAgent ? EMAIL_SALE_CENTER : '',
      auto_text: true,
      inline_css: true,
      merge: true,
      merge_language: 'handlebars',
      headers: {
        'Reply-To': agentInformation.email
      },
      from_name: valuesForm.fullnameAgent,
      subject: 'Pivot Health - Health Insurance Quote',
      merge_vars: [],
      global_merge_vars: [
        {
          name: 'agent',
          content: {
            name: valuesForm.fullnameAgent,
            phone: completePhone,
            phonePlain: onlyDigits(valuesForm.phone),
            email: agentInformation.email
          }
        },
        {
          name: 'applicant',
          content: {
            fname: valuesForm.fname,
            lname: valuesForm.lname,
            dob: applicant.stringDOB,
            gender: getGender(applicant.gender)
          }
        },
        {
          name: 'members',
          content: makeMembers(hcStorage.members)
        },
        {
          name: 'messages',
          content: valuesForm.message.split(/\r\n|\r|\n/g).filter(Boolean)
        },
        {
          name: 'zip',
          content: hcStorage.location.zip_code
        },
        {
          name: 'sdate',
          content: hcStorage.sdate
        },
        {
          name: 'quoteDate',
          content: dateToString(new Date())
        }
      ]
    }
  }

  return result
}

export default makeBase
